import * as React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { LoaderBolt } from "@ui/Atoms/LoaderBolt";

import * as Styled from "./CalendarNotification.styled";

interface Props {
  testId?: string;
  className?: string;
  children: React.ReactNode;
}

const LoaderWithText = (props: Props): React.ReactElement => {
  return (
    <TestWrapper testId={props.testId}>
      <Styled.TextIconContainer className={props.className}>
        <LoaderBolt size={66} />

        <Styled.Text>{props.children}</Styled.Text>
      </Styled.TextIconContainer>
    </TestWrapper>
  );
};

export { LoaderWithText };
